import * as d3 from 'd3';
import $ from 'jquery';
import * as React from 'react';
import { observer } from 'mobx-react';
import { IOptimizedTrajectoryAreaParams } from './IOptimizedTrajectoryAreaParams';
import { ITrajectoryCoordinate } from 'Data';

@observer
export class OptimizedTrajectoryArea extends React.Component<IOptimizedTrajectoryAreaParams> {
  private pathNode: any;
  private self: any;

  constructor(props: IOptimizedTrajectoryAreaParams) {
    super(props, undefined);
  }

  componentDidUpdate() {
    if (this.pathNode) {
      $(this.pathNode).appendTo($(this.pathNode).parents('#svgWithTrajectories'));
    }
  }

  render() {
    this.self = this;
    if (this.props.coordinates == null) return <g></g>;

    let line = d3.svg
      .line<ITrajectoryCoordinate>()
      .x((d: ITrajectoryCoordinate) => {
        return this.props.x(d.x);
      })
      .y((d: ITrajectoryCoordinate) => {
        return this.props.y(d.y);
      })
      .interpolate('linear ');
    return (
      <path
        className={this.props.className}
        stroke={this.props.trajectoryColor}
        fill={this.props.trajectoryColor}
        d={line(this.props.coordinates)}
        ref={input => {
          this.pathNode = input;
        }}
      ></path>
    );
  }
}
